import React, { ChangeEvent, FC } from 'react'
import styles from 'styles/components/form.module.scss'
import text from 'styles/utility/text.module.scss'
import { CardInner } from 'components/Card'
import { Spacer } from 'components/Utility'

type Props = {
  breadId: string
  breadName: string
  imageUrl: string
  isSelected: boolean
  selectBread: (event: ChangeEvent<HTMLInputElement>) => void
}

const ScheduleCollectiveCard: FC<Props> = (props) => {
  const { breadId, breadName, imageUrl, isSelected, selectBread } = props

  return (
    <CardInner>
      <label className={styles.checkbox} htmlFor={breadId}>
        <input
          className={styles.checkbox__input}
          checked={isSelected}
          id={breadId}
          onChange={(e) => selectBread(e)}
          type="checkbox"
        />
        <span className={styles.checkbox__dummy_large} tabIndex={0} />
        <Spacer size={16} />
        <div className={styles.checkbox__image}>
          <img src={imageUrl} alt={breadName} />
        </div>
        <Spacer size={16} />
        <span className={text.font_bold}>{breadName}</span>
      </label>
    </CardInner>
  )
}

export default ScheduleCollectiveCard
